var map = {
	"./arrow-circle-broken-right.svg": 9255,
	"./arrow-circle-right.svg": 3239,
	"./check-circle.svg": 2937,
	"./logo-on-dark.svg": 6479,
	"./logo-on-white.svg": 3008,
	"./register.svg": 6817,
	"./scroll.svg": 9734,
	"./slide-01.svg": 8570,
	"./slide-02.svg": 7658,
	"./slide-03.svg": 8956,
	"./slide-04.svg": 8950,
	"./slide-05.svg": 7946,
	"./slide-06.svg": 5825,
	"./slide-07.svg": 3477,
	"./slide-08.svg": 3029,
	"./slide-09.svg": 5836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3413;